export default "__VITE_ASSET__DAsFaGzE__"